"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonStyled = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var _styled_1 = require("./");
exports.ButtonStyled = styled_components_1.default(function (props) { return (react_1.default.createElement(_styled_1.DefaultStyled, __assign({}, props, { as: "button" }))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n  }\n  @media (max-width: ", ") {\n  }\n"], ["\n  @media (max-width: ", ") {\n  }\n  @media (max-width: ", ") {\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointTablet;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var templateObject_1;
//# sourceMappingURL=ButtonStyled.js.map